/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

import {useMemo} from 'react';
import {dlsColor} from '../theme/theme';
import {useThemeMode} from '../theme/useThemeContext';

interface useImpactIconColorResult {
  red: string;
  blue: string;
  green: string;
  paleBlue: string;
}

/**
 * The useImpactIconColor hook returns the colors needed for the SC Device Shock
 * Sensor impact icons, re-resolving them when the theme mode changes.
 *
 * ```typescript
 *
 * import {useImpactIconColor} from './useImpactIconColor';
 *
 * const {red, blue, green, paleBlue} = useImpactIconColor();
 *
 * ```
 */
export const useImpactIconColor = (): useImpactIconColorResult => {
  const {mode} = useThemeMode();
  const colors = useMemo(() => {
    const red = dlsColor('caRed');
    const blue = dlsColor('aaBlue');
    const green = dlsColor('caGreen');
    const paleBlue = dlsColor('paleBlue');
    return {
      blue, red, green, paleBlue
    };
  }, [mode]);
  return colors;
};
